export default __webpack_public_path__ + "static/media/Popcorn_logo.73f0d90b.png";